import { S3Client } from "@aws-sdk/client-s3";
import axios from "axios";

const {
  REACT_APP_REGION: REGION,
  REACT_APP_YOUR_ACCESS_KEY_ID: YOUR_ACCESS_KEY_ID,
  REACT_APP_YOUR_SECRET_ACCESS_KEY: YOUR_SECRET_ACCESS_KEY,
  REACT_APP_API_URL: API_URL,
  REACT_APP_CONSUMER_PORTAL_API_KEY: CONSUMER_PORTAL_API_KEY,
} = process.env;

export const s3Client: S3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: YOUR_ACCESS_KEY_ID || "",
    secretAccessKey: YOUR_SECRET_ACCESS_KEY || "",
  },
});

export const axiosAWSConsumer = axios.create({
  baseURL: API_URL,
  headers: {
    "API-KEY": CONSUMER_PORTAL_API_KEY,
  },
});

export const axiosAWSPortalConsumer = axios.create({
  baseURL: "https://api.myprotectall.com/consumer_portal",
  headers: {
    "X-API-KEY": "T4x8ndqQXi7SQS2qut58a8iF5SyNO1P381HqLWK4",
  },
});
